import { Empty as AntdEmpty } from "antd";

export default function Empty({ title, text }) {
  return (
    <div className="select-none mt-2">
      <AntdEmpty
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        description={text}
      />
    </div>
  );
}
